import { Stack, styled } from '@mui/material';
import { SelectMenu } from '../../../../../../components/atoms/SelectMenu';
import { LiveSearchBox } from '../../../../../../components/atoms/LiveSearchBox';
import { DateTimePicker } from '../../../../../../components/atoms/DateTimePicker';
import { Tags } from '../../../../../../components/organisms/Tags';

export const StyledStack = styled(Stack)((props: { isMobileView: boolean }) =>`
  min-width: ${props.isMobileView ? '0px' : '300px'};
  max-width: 300px;
`);

export const StyledSelectMenu = styled(SelectMenu)((props: { isMobileView: boolean }) =>`
  min-width: ${props.isMobileView ? '0px' : '300px'};
`);

export const StyledLiveSearchBox = styled(LiveSearchBox)((props: { isMobileView: boolean }) =>`
  min-width: ${props.isMobileView ? '0px' : '300px'};
`);

export const StyledDateTimePicker= styled(DateTimePicker)((props: { isMobileView: boolean }) =>`
  min-width: ${props.isMobileView ? '0px' : '300px'};
`);

export const StyledTags = styled(Tags)((props: { isMobileView: boolean }) =>`
  min-width: ${props.isMobileView ? '0px' : '300px'};
`);